import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: number;
  slug: string;
  title: string;
  author: string;
  cover: string;
  categoryName: string;
  rating: number;
  views: number;
  chapters?: number;
  status?: string;
  updatedAt?: string;
}

function formatViews(views: number): string {
  if (views >= 1000000) return `${(views / 1000000).toFixed(1)}万`;
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return views.toString();
}

export default function ComicCard({ id, slug, title, author, cover, categoryName, rating, views, chapters, status, updatedAt }: ComicCardProps) {
  return (
    <article className="group" data-product-shop>
      <Link to={`/comic/${slug}`} className="block cursor-pointer">
        <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3 bg-background-200">
          <img
            src={cover}
            alt={`${title} - 韩漫之家推荐韩国漫画`}
            title={`${title} - 免费韩漫在线阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
          {status === '连载中' && (
            <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
              连载
            </span>
          )}
          {status === '已完结' && (
            <span className="absolute top-2 left-2 px-2 py-0.5 bg-secondary-500 text-background-50 text-xs font-medium rounded-full">
              完结
            </span>
          )}
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 pt-8 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <span className="text-background-50 text-xs flex items-center gap-1">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
              {rating} · {formatViews(views)}次阅读
            </span>
          </div>
        </div>
        <h3 className="text-sm font-heading font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <p className="text-xs text-foreground-600 mt-1 line-clamp-1">
          {author} · {categoryName}
        </p>
        {chapters && (
          <p className="text-xs text-foreground-500 mt-0.5">
            共{chapters}话
            {updatedAt && <span className="ml-1">· 更新至{updatedAt}</span>}
          </p>
        )}
      </Link>
    </article>
  );
}